import React, { forwardRef, useEffect, useRef, useState } from 'react';

import { DigitalPlatformTabs1 } from '../DigitalPlatform1/constants';
import Tag from '../UIkit/Tag';
import { debounce } from '../../utils/debounce';

import style from './DigitalPlatformMobile.module.css';
import CardMobile from './CardMobile';
import CardScroll from './CardScroll';

const CARD_WIDTH = 245;
const CARD_GAP = 0;
const SWIPE_THRESHOLD = 20;

const DigitalPlatformMobile = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const carouselRef = useRef<HTMLDivElement>(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [containerWidth, setContainerWidth] = useState<number | null>(null);

  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  const calculateVisibleCards = debounce(() => {
    if (carouselRef.current) {
      const availableWidth = carouselRef.current.parentElement
        ? carouselRef.current.parentElement.offsetWidth
        : carouselRef.current.offsetWidth;
      const cardsCount = Math.floor((availableWidth + CARD_GAP) / (CARD_WIDTH + CARD_GAP));
      const calculatedWidth = cardsCount * (CARD_WIDTH + CARD_GAP) - CARD_GAP;
      setContainerWidth(calculatedWidth);
    }
  }, 200);

  useEffect(() => {
    calculateVisibleCards();
    window.addEventListener('resize', calculateVisibleCards);
    return () => window.removeEventListener('resize', calculateVisibleCards);
  }, []);

  const onTabChange = (id: number) => {
    setActiveTab(id);
    setCurrentIndex(0);
  };

  const next = () => {
    if (isTransitioning) return;

    setIsTransitioning(true);
    const itemsLength = DigitalPlatformTabs1[activeTab].Items.length;

    if (currentIndex >= itemsLength - 1) {
      setCurrentIndex(0);
    } else {
      setCurrentIndex(currentIndex + 1);
    }

    setTimeout(() => setIsTransitioning(false), 300);
  };

  const prev = () => {
    if (isTransitioning) return;

    setIsTransitioning(true);
    const itemsLength = DigitalPlatformTabs1[activeTab].Items.length;

    if (currentIndex <= 0) {
      setCurrentIndex(itemsLength - 1);
    } else {
      setCurrentIndex(currentIndex - 1);
    }

    setTimeout(() => setIsTransitioning(false), 300);
  };

  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.targetTouches[0].clientX);
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;

    if (distance > SWIPE_THRESHOLD) {
      next();
    }

    if (distance < -SWIPE_THRESHOLD) {
      prev();
    }
  };

  const offset = -currentIndex * (CARD_WIDTH + CARD_GAP);

  return (
    <article className={style.container} id="platform1">
      <div className={style.title}>
        <h2 className={style.h2}>Программные продукты INNERICA</h2>
        <Tag title="Продукт" color="grey" />
      </div>
      <div>
        <div className={style.tabs}>
          {DigitalPlatformTabs1.map(tab => (
            <button
              key={`DigitalPlatform_Tabs${tab.Name}`}
              onClick={() => onTabChange(tab.Id)}
              className={tab.Id === activeTab ? style.activeTab : ''}
            >
              {tab.Name}
            </button>
          ))}
        </div>

        <div
          className={style.carousel_container}
          ref={carouselRef}
          style={{ width: containerWidth ? `${containerWidth}px` : 'auto' }}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div
            className={style.carousel}
            style={{
              transform: `translateX(${offset}px)`,
              transition: isTransitioning ? 'transform 0.3s ease-in-out' : 'none',
            }}
          >
            {DigitalPlatformTabs1[activeTab].Items.map((el, index) => (
              <CardMobile el={el} key={`card-${activeTab}-${index}`} style={{ minWidth: `${CARD_WIDTH}px` }} />
            ))}
          </div>
        </div>

        <CardScroll
          currentIndex={currentIndex % DigitalPlatformTabs1[activeTab].Items.length}
          length={DigitalPlatformTabs1[activeTab].Items.length}
          onClickNextHandler={next}
          onClickPrevHandler={prev}
        />
      </div>
    </article>
  );
};
export default DigitalPlatformMobile;
